import TataLogo from "@app/assets/svg/TataLogo";
import { CollateralType, CreditType } from "@app/configs/constants";
import ROUTE from "@app/navigationApp/routes";
import { ArrowsLeftRight, CaretRight, ChevronRight } from "@app/sharedComponents/Icons/Icons";
import { useAppSelector } from "@app/store/hooks";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import BajajLogo from "../../../../assets/Icons/BajajLogo"
import DSPLogo from "../../../../assets/Icons/DSPLogo"
import { isLASFlowEnabled } from "@app/utils/utils";

const ElevateHeader = ({accountId,switchLender,navigation,userDetails,setViewAllLoansDetails}) =>{
    console.log('switchLender',switchLender);
    const currentLender = userDetails?.linkedCredits[0]?.lendingPartnerId;
    const creditType = userDetails?.linkedCredits[0]?.creditType;

    const isLasFlowEnabled = isLASFlowEnabled();

    const getLenderLogo = (id) => {
        const logoObj ={
        tata: <TataLogo/>,
        bajaj: <BajajLogo/>,
        dsp: <DSPLogo color1={themeColorSet['icon-primary']}/>,
        }
        return logoObj[id?.toLowerCase()];
    }

    const handleViewAllLoans = () => {
        setViewAllLoansDetails(true)
    }

    return(
        isLasFlowEnabled ? 
        <ThemedView backgroundColor="bg-fill-primary" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary" py="md" px="lg" alignItems="center" flexDirection="row" justifyContent="space-between">
            <ThemedView flexDirection="row" alignItems="center">
                <ThemedView ml="sm">
                    <ThemedText variant="b4m" color="text-secondary" mb="xs">Currently on</ThemedText>
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedText variant="b3m" color="text-primary" mr="sm">Loan against {creditType === CreditType.CREDIT_LINE_LAS ? 'shares' : 'MF'}</ThemedText>
                        {getLenderLogo(currentLender)}
                    </ThemedView>
                </ThemedView>
            </ThemedView>
            <ThemedPressable flexDirection="row" alignItems="center" onPress={handleViewAllLoans}>
                <ThemedText variant="b3s" color="text-action-primary" mr="xs">View all loans</ThemedText>
                <CaretRight size="16" color={themeColorSet['text-action-primary']} />
            </ThemedPressable>

        </ThemedView>
        :
        <>
            <ThemedView backgroundColor="bg-fill-primary" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary" py="md" px="lg" alignItems="center" flexDirection="row" justifyContent="space-between">
                <ThemedView flexDirection="row" alignItems="center">
                    <ThemedView width={8} height={36} style={{backgroundColor:'#0071BB'}} borderRadius="2xs"/>
                    <ThemedView ml="sm">
                        <ThemedText variant="b3s" color="text-primary" mb="xs">Switch to {switchLender?.lenderInfo?.lenderName}</ThemedText>
                        <ThemedText variant="b4m" color="text-secondary">Click on switch to go to other loan</ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedPressable flexDirection="row" alignItems="center" onPress={()=>{navigation.navigate(ROUTE.ELEVATE_SWITCHING,{accountId,targetCreditId:switchLender?.creditId})}}>
                    <ArrowsLeftRight size={20} color={themeColorSet["text-action-primary"]} />
                    <ThemedText color="text-action-primary" ml="xs">Switch</ThemedText>
                </ThemedPressable>

            </ThemedView>
        </>
    )
}

export default ElevateHeader;